module.exports = __webpack_public_path__ + "img/car-door.f0105b8e.png";